
import { COLUMNS, ROWS, HEIGHT, WIDTH, getRandomCoords, createGrid, forEachRow, forEachColumn, getIndex, setCell, drawRect } from '../utils';

function initCanvas() {
  const canvas = document.createElement('canvas');
  canvas.setAttribute('width', COLUMNS)
  canvas.setAttribute('height', ROWS)
  // document.body.appendChild(canvas);
  return canvas.getContext('2d');
}

export class RippleBeatMode {
  constructor({ addBeatListener }) {
  
    this.state = {
      ripples: []
    };

    addBeatListener(({major}) => {
      this.spawnRipple({
        x: Math.floor(WIDTH / 2),
        y: Math.floor(HEIGHT / 2),
      });
    });

    const rnd1 = Math.random();
    if (rnd1 < 0.2) {
      this.modifier = 'tall';
    }
    if (rnd1 > 0.8) {
      this.modifier = 'wide';
    }

  }

  spawnRipple(coords, color) {
    const existingRippleAtCoords = this.state.ripples.find(r => r.x === coords.x && r.y === coords.y);
    if (existingRippleAtCoords && existingRippleAtCoords.time < WIDTH / 4) {
      return;
    }
    this.state.ripples.push({
      ... coords,
      time: 0,
      color
    });
  }

  update(delta) {

    const state = this.state;
    const rippleSpeed = 1 / 20;
    
    state.ripples.forEach((ripple, i) => {
      ripple.time += rippleSpeed * delta;
      ripple.size = Math.floor(ripple.time / 2);
      if (ripple.size % 2 === 0) {
        ripple.size += 1;
      }
      if (ripple.size > WIDTH * 2) {
        state.ripples = state.ripples.filter((r, j) => i !== j)
      }
    });

  }

  getData() {

    const data = createGrid();
    this.state.ripples.forEach(({x, y, size, color}) => {
      let width = size;
      let height = size;
      if (this.modifier === 'wide') {
        width = WIDTH + 2;
      }
      if (this.modifier === 'tall') {
        height = HEIGHT + 2;
      }
      drawRect(data, {x, y, width, height}, {
        centered: true,
        color
      })
      
    });

    return data;


  }
}
